import React from "react";
import { BooleanField, BulkDeleteButton, Datagrid, EditButton, List, TextField } from "react-admin";
import { SearchableList } from "../SearchableList";

export const ListComponent: React.FC = () => {
  return (
    <List perPage={100}>
      <SearchableList>
      <Datagrid
        rowClick="show"
        bulkActionButtons={<BulkDeleteButton mutationMode="optimistic" />}
        sx={{
          '& tbody tr:nth-of-type(odd)': { backgroundColor: '#1a1a1a' },
          '& tbody tr:nth-of-type(even)': { backgroundColor: '#000000' },
        }}
      >
        <TextField source="name" />
        <TextField source="created_at" />
        <BooleanField label="Active" source="active" />
        <BooleanField label="Is Techeat" source="isTecheat" />
        <EditButton />
      </Datagrid>
      </SearchableList>
    </List>
  );
};
